import port0 from '../img/portImages/port0.jfif';
import port1 from '../img/portImages/port1.jfif';
import port2 from '../img/portImages/port2.jfif';
import port3 from '../img/portImages/port3.jfif';
import port4 from '../img/portImages/port4.png';
import port5 from '../img/portImages/port5.jfif';
import port6 from '../img/portImages/port6.jfif';
import port7 from '../img/portImages/port7.jpeg';

const portfolios = [
    {
        id:1,
        category: 'ReactJs',
        link1: 'https://text-utilsz.web.app/',
        link2: 'https://github.com/naba079/Text-Utilization',
        icon1: 'Go',
        icon2: 'Git',
        image: port0,
        title: 'Text Utilization'
    },
    {
        id:1,
        category: 'ReactJs',
        link1: 'www.youtube.com',
        link2: 'https://github.com/naba079/Monkey-News',
        icon1: 'Go',
        icon2: 'Git',
        image: port1,
        title: 'News App'
    },
    {
        id:2,
        category: 'JavaScript',
        link1: 'https://todo-list-85950.web.app/',
        link2: 'https://github.com/naba079/ToDo-List',
        icon1: 'Go',
        icon2: 'Git',
        image: port2,
        title: 'ToDo-List'
    },
    // {
    //     id:3,
    //     category: 'JavaScript',
    //     link1: 'www.youtube.com',
    //     link2: 'www.github.com',
    //     icon1: 'Go',
    //     icon2: 'Git',
    //     image: port3,
    //     title: 'Tic-Tac-Toe'
    // },
    // {
    //     id:4,
    //     category: 'JavaScript',
    //     link1: 'www.youtube.com',
    //     link2: 'www.github.com',
    //     icon1: 'Go',
    //     icon2: 'Git',
    //     image: port4,
    //     title: 'Snake Game'
    // },
    {
        id:5,
        category: 'Css',
        link1: 'www.youtube.com',
        link2: 'https://github.com/naba079/Modern_Website',
        icon1: 'Go',
        icon2: 'Git',
        image: port5,
        title: 'Modern Website'
    },
    {
        id:6,
        category: 'JavaScript',
        link1: 'https://naba079.github.io/Project%203/',
        link2: 'https://github.com/naba079/naba079.github.io/tree/main/Project%203',
        icon1: 'Go',
        icon2: 'Git',
        image: port6,
        title: 'Calculator'
    },
    {
        id:7,
        category: 'Html',
        // category: 'Css',
        link1: 'https://naba079.github.io/Project2/',
        link2: 'https://github.com/naba079/naba079.github.io/tree/main/Project2',
        icon1: 'Go',
        icon2: 'Git',
        image: port7,
        title: 'Gym Static Website'
    },
]

export default portfolios;